import React, { useState } from "react";
import { Layout, theme } from "antd";
import { motion, AnimatePresence } from "motion/react";
import chakra from "../../Assets/Chakra/7-chakras.webp";
import pose1 from "../../Assets/Chakra/1.jpg";
import pose2 from "../../Assets/Chakra/2.jpg";
import pose3 from "../../Assets/Chakra/3.jpg";
import pose4 from "../../Assets/Chakra/4.jpg";
import pose5 from "../../Assets/Chakra/5.jpg";
import pose6 from "../../Assets/Chakra/6.jpg";
import pose7 from "../../Assets/Chakra/7.jpg";
import root1 from "../../Assets/Chakra/malasana-root-1.webp";
import root2 from "../../Assets/Chakra/padmasana-root-1-6-7.webp";
import root3 from "../../Assets/Chakra/tree-root-1.webp";
import root4 from "../../Assets/Chakra/setu-bandha-root-1.webp";
import root5 from "../../Assets/Chakra/janu-shirsha-root-1-2.webp";
import sacral1 from "../../Assets/Chakra/baddha-konasana-2.webp";
import sacral2 from "../../Assets/Chakra/parivrtta.jpeg";
import sacral3 from "../../Assets/Chakra/ardha-chandrasana-2.webp";
import sacral4 from "../../Assets/Chakra/eka-pada-raja-kapotasana-2.webp";
import tri1 from "../../Assets/Chakra/navasana-3.webp";
import tri2 from "../../Assets/Chakra/trikonasana-3.webp";
import tri3 from "../../Assets/Chakra/Parighasana-1.webp";
import tri4 from "../../Assets/Chakra/bhujangasana-3-4.webp";
import h1 from "../../Assets/Chakra/bhujangasana-3-4.webp";
import h2 from "../../Assets/Chakra/ushtrasana-4-5.webp";
import h3 from "../../Assets/Chakra/Anahatasana-dog-4.webp";
import h4 from "../../Assets/Chakra/Matsyasana-4-5-6-7.webp";
import t1 from "../../Assets/Chakra/Matsyasana-4-5-6-7.webp";
import t2 from "../../Assets/Chakra/halasana-5.webp";
import t3 from "../../Assets/Chakra/adho-mukha-shvanasana-5-6-7.webp";
import t4 from "../../Assets/Chakra/balasana-5-6-7.webp";
import t5 from "../../Assets/Chakra/sarvangasana-5.webp";
import t6 from "../../Assets/Chakra/ushtrasana-4-6.webp";
import e1 from "../../Assets/Chakra/balasana-5-6-7.webp";
import e2 from "../../Assets/Chakra/adho-mukha-shvanasana-5-6-7.webp";
import e3 from "../../Assets/Chakra/Matsyasana-4-5-6-7.webp";
import e4 from "../../Assets/Chakra/shirshasana-headstand-pose-6-7.webp";
import e5 from "../../Assets/Chakra/padmasana-root-1-6-7.webp";
import c1 from "../../Assets/Chakra/shirshasana-headstand-pose-6-7.webp";
import c2 from "../../Assets/Chakra/adho-mukha-shvanasana-5-6-7.webp";
import c3 from "../../Assets/Chakra/Matsyasana-4-5-6-7.webp";
import c4 from "../../Assets/Chakra/padmasana-root-1-6-7.webp";
import c5 from "../../Assets/Chakra/balasana-5-6-7.webp";
import c6 from "../../Assets/Chakra/shavasana.webp";
import AdvertisementCard from "../AdvertisementCard";

const { Content } = Layout;

const Chakra = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const ismobile = window.innerWidth <= 375 && window.innerHeight <= 667;

  const [selectedChakra, setSelectedChakra] = useState(null);

  const wrapperStyle = {
    padding: ismobile ? "12px" : "24px",
    maxWidth: ismobile ? "360px" : "100%",
    margin: "0 auto",
    background: colorBgContainer,
    borderRadius: borderRadiusLG,
    lineHeight: 1.6,
  };

  const imageStyle = {
    width: "100%",
    maxWidth: ismobile ? "260px" : "300px",
    height: "auto",
    borderRadius: 10,
    display: "block",
    margin: "10px auto",
  };

  const selectStyle = {
    width: ismobile ? "90%" : "50%",
    padding: "10px",
    fontSize: ismobile ? 15 : 16,
    borderRadius: 6,
    border: "1px solid #ccc",
  };

  const tableStyle = {
    width: "100%",
    maxWidth: ismobile ? "320px" : "600px",
    margin: "10px auto",
    borderCollapse: "collapse",
    fontSize: ismobile ? "14px" : "16px",
    tableLayout: "fixed",
  };

  const cellStyle = {
    padding: "12px 10px",
    borderBottom: "1px solid #ddd",
    verticalAlign: "top",
    whiteSpace: "nowrap",
    width: "120px",
  };
  const details = [
    {
      name: "Muladhara Chakra or Root Chakra ",
      img: pose1,
      sanskrit: "Muladhara Chakra",
      english: "Root Chakra",
      location: "Base of the spine",
      color: "Crimson",
      mantra: "lam",
      petals: 4,
      element: "earth",
      focus: "Physical survival, Self-preservation and security",
      content: (
        <>
          <h2>Benefits of the Root Chakra</h2>
          <p>Benefits of a balanced Root Chakra:</p>
          <ol>
            <li>
              <b>Solid Foundation:</b> You will feel a solid foundation to
              overcome challenges in life.
            </li>
            <li>
              <b>Sense of Security:</b> You will feel safe in the world.
            </li>
            <li>
              <b>Physical Strengthening:</b>Blood circulation, immunity, and
              skeletal system will be strengthened.
            </li>
            <li>
              <b>Material Well-Being:</b> When this chakra is functioning well,
              the ability to fulfill the basic needs of life (food, shelter,
              money) will increase.
            </li>
            <li>
              <b>Peace of Mind:</b> Anxiety, fear, and feeling alienated will
              decrease.
            </li>
          </ol>
          <h2>Yoga Poses to Balance the Root Chakra</h2>
          <p>
            These asanas focus on the lower part of our body (feet, heels,
            thighs) and stimulate the Root Chakra.
          </p>

          <h2>Malasana - Garland Pose / Squat </h2>
          <p>
            <b>How to do it:</b> Stand with your legs wide apart, bend your
            knees and squat. Bring your hands together and bring them in front
            of your chest.
          </p>

          <img
            src={root1}
            alt="Malasana(Squat)yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />

          <p>
            <b>Benefits:</b> Increases blood flow to the hips and pelvis.
          </p>
          <h2>Padmasana - Lotus Pose</h2>
          <p>
            <b>How to do it:</b> Sit on the floor, cross your legs, and place
            each foot on the opposite thigh.
          </p>

          <img
            src={root2}
            alt="Padmasana(Lotus Pose)yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />

          <p>
            <b>Benefits:</b> Calms the mind and is a good asana for meditation.
            Strengthens the sense of grounding.
          </p>
          <h2>Vrikshasana - Tree Pose</h2>
          <p>
            <b>How to do it:</b> Stand on one leg, place the other leg on the
            opposite thigh, and raise your hands up in a namaskar pose.
          </p>
          <img
            src={root3}
            alt="Vrikshasana (Tree Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />

          <p>
            <b>Benefits:</b> Develops balance and stability. Connects the mind
            to the earth.
          </p>
          <h2>Setu Bandhasana - Bridge Pose</h2>
          <p>
            <b>How to do it:</b> Lie on your back, bend your knees, and try to
            grab your ankles with your hands. Your thighs should be parallel to
            the ground.
          </p>
          <img
            src={root4}
            alt="Setu Bandhasana (Bridge Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />

          <p>
            <b>Benefits:</b> Strengthens the thighs and heels, and stimulates
            the root chakra.
          </p>
          <h2>Janu Sirsasana - Head-to-Knee Pose</h2>
          <p>
            <b>How to do it:</b> Extend one leg, fold the other leg so that it
            touches the thigh, and bend forward to grab the toes of the extended
            leg.
          </p>
          <img
            src={root5}
            alt="Janu Sirsasana (Head-to-Knee Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />

          <p>
            <b>Benefits:</b> Stretches the hips and thighs, and promotes energy
            flow.{" "}
          </p>
          <p>
            <b>Mantra:</b> Chanting the mantra "Lam" during meditation can
            increase the vibration of this chakra.
          </p>
          <p>
            By practicing these yoga asanas and practices daily, you can balance
            your root chakra and build a solid foundation in life.
          </p>
        </>
      ),
    },
    {
      name: "Svadhisthana Chakra or Sacral Chakra",
      img: pose2,
      alt: "Sacral Chakra",
      sanskrit: "Swadhishthana Chakra",
      english: "Sacral Chakra",
      location: "sacrum",
      color: "Orange",
      mantra: "Vam",
      petals: 6,
      element: "Water",
      focus: "Creativity, sexuality, and emotional expression",
      content: (
        <>
          <h2>Benefits:</h2>
          <p>
            The Sacral Chakra is the center of emotions, creativity, and
            happiness. It is located below the navel in our body.
          </p>
          <h2>Benefits of balancing the Sacral Chakra:</h2>
          <ol>
            <li>
              <b>Creative Expression:</b> You will find impressive energy in
              creative activities such as art, music, and writing.
            </li>
            <li>
              <b>Emotional Freedom:</b> The ability to express emotions freely
              and healthily will develop.
            </li>
            <li>
              <b>Happiness and Pleasure:</b> You will be able to derive joy from
              even the smallest experiences in life.
            </li>
            <li>
              <b>Intimacy in Relationships:</b> You will be able to develop
              emotional and happy relationships.
            </li>
            <li>
              <b>Physical Well-Being:</b> The health of the kidneys, joints, and
              reproductive system will improve.
            </li>
          </ol>
          <h2>Yoga Poses for Balancing the Swadhisthana Chakra</h2>
          <p>
            These poses stretch the hips and lower abdomen, stimulating the
            energy of the Swadhisthana Chakra.
          </p>
          <h2>Baddha Konasana - Bound Angle Pose / Butterfly Pose</h2>
          <p>
            <b>How to do it:</b> Sit, fold your legs in front, and bring your
            feet together. Slowly move your knees up and down.
          </p>
          <img
            src={sacral1}
            alt="Baddha Konasana (butterfly pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood circulation in the hips and
            abdomen, promoting energy flow.
          </p>

          <h2>Parivrtta Janu Sirsasana - Revolved Head-to-Knee Pose</h2>
          <p>
            <b>How to do it:</b> Extend one leg to the side, keep the other leg
            folded, bend towards the extended leg.
          </p>
          <img
            src={sacral2}
            alt="Parivrtta Janu Sirsasana (Revolved Head-to-Knee Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Provides a deep stretch to the hips and encourages
            emotional release.
          </p>

          <h2>Ardha Chandrasana - Crescent Moon Pose</h2>
          <p>
            <b>How to do it:</b> Place one leg in front, bend the knee at 90
            degrees. Extend the back leg. Raise your arms up and gently push
            your hips to the right.
          </p>
          <img
            src={sacral3}
            alt="Ardha Chandrasana (Crescent Moon Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Strengthens the hips and abdominal muscles,
            improves energy flow.
          </p>

          <h2>Eka Pada Rajakapotasana - Pigeon Pose</h2>
          <p>
            <b>How to do it:</b> Place one leg in front, and extend the other
            leg behind. Keep your upper body straight and push your chest
            forward.
          </p>
          <img
            src={sacral4}
            alt="Eka Pada Rajakapotasana (Pigeon Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> A very popular asana for releasing emotional blocks
            in the lumbar region.
          </p>

          <p>
            <b>Orange:</b> Seeing, wearing, or imagining the color orange around
            you can increase the energy of the chakra.
          </p>
          <p>
            <b>Mantra:</b> Chanting the mantra "Vam" during meditation can
            increase the vibration of this chakra.
          </p>
          <p>
            By practicing these yoga asanas and practices daily, you can balance
            your Swadhisthana chakra and express creativity, happiness, and
            healthy emotions.
          </p>
        </>
      ),
    },
    {
      name: "Manipura Chakra or Solar plexus or Navel chakra",
      img: pose3,
      alt: "Solar plexus or Navel chakra",
      sanskrit: "Manipura Chakra",
      english: "Solar plexus or Navel chakra",
      location: "Upper abdomen",
      color: "Yellow",
      mantra: "Ram",
      petals: 10,
      element: "Fire",
      focus: "power, will and self-esteem",
      content: (
        <>
          <h2>Benefits of the Manipura Chakra</h2>
          <p>Benefits of balancing the Manipura Chakra:</p>
          <ol>
            <li>
              <b>Power and Confidence:</b>You gain confidence and inner strength
              to face challenges.
            </li>
            <li>
              <b>Decision-making ability:</b> You can make the right decisions
              quickly and confidently.
            </li>
            <li>
              <b>Self-esteem:</b> Your self-esteem and ability to love yourself
              will grow.
            </li>
            <li>
              <b>Personality development:</b> Your true personality will emerge.
            </li>
            <li>
              <b>Physical well-being:</b> The functioning of organs such as the
              digestive system, liver, and pancreas will improve.Physical
              well-being: The functioning of organs such as the digestive
              system, liver, and pancreas will improve.
            </li>
          </ol>
          <h2>Yoga Poses to Balance the Manipura Chakra</h2>
          <p>
            These poses stimulate the Manipura Chakra by focusing energy in the
            core and solar plexus.
          </p>
          <h2>Navasana - Boat Pose</h2>
          <p>
            <b>How to do it:</b> Sit on your back and lift your legs up. Extend
            your arms straight out in front of your legs. Your body should form
            a "V" shape.
          </p>
          <img
            src={tri1}
            alt="Navasana (Boat Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Strengthens your abdominal muscles and increases
            your sense of power and balance.
          </p>

          <h2>Trikonasana - Triangle Pose</h2>
          <p>
            <b>How to do it:</b> Stand with your legs wide apart and try to
            touch the toes of the opposite leg with one hand. Extend the other
            hand up.
          </p>
          <img
            src={tri2}
            alt="Trikonasana (Triangle Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Stretches the abdominal area and promotes energy
            flow.
          </p>

          <h2>Parighasana - Gate Pose</h2>
          <p>
            <b>How to do it:</b> Sit on one knee and extend the other leg out to
            the side. Bend to the side of the extended leg and grab the toes
            with your hand.
          </p>
          <img
            src={tri3}
            alt="Parighasana (Gate Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Stretches the lateral abdominal muscles and
            releases the chakra energy.
          </p>

          <h2>Bhujangasana - Cobra Pose</h2>
          <p>
            <b>How to do it:</b> Lie on your stomach, place your hands under
            your shoulders, and slowly lift your upper body up.
          </p>
          <img
            src={tri4}
            alt="Bhujangasana (Cobra Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Contracts and stretches the abdominal area,
            activating the solar plexus.
          </p>

          <h2>Uddiyana Bandha - Abdominal Lock</h2>
          <p>
            <b>How to do it:</b> In a standing position, exhale completely, pull
            your stomach inward, and push your chest out.
          </p>
          <p>
            <b>Warning:</b> This should only be done under the guidance of a
            practitioner.
          </p>
          <p>
            <b>Benefits:</b> Stimulates the abdominal organs, improves
            digestion, and releases the Manipura chakra energy.
          </p>

          <p>
            <b>Sun Power:</b> Sitting in the sunlight for a while in the morning
            will replenish the energy of this chakra.
          </p>
          <p>
            <b>Yellow:</b> Seeing, wearing, or imagining the color yellow around
            you can increase the energy of the chakra.
          </p>
          <p>
            <b>Mantra:</b> Chanting the mantra "Ram" during meditation can
            increase the vibration of this chakra.
          </p>
          <p>
            By practicing these yoga asanas and practices daily, you can balance
            your Manipura Chakra and manifest self-confidence, inner strength,
            and determination.
          </p>
        </>
      ),
    },
    {
      name: "Anahata Chakra or Heart Chakra",
      img: pose4,
      alt: "Anahata Chakra",
      sanskrit: "Anahata Chakra",
      english: "Heart Chakra",
      location: "Within the center of the chest",
      color: "Green",
      mantra: "Yam",
      petals: 12,
      element: "Air",
      focus: "Peace, love and Empathy",
      content: (
        <>
          <p>
            The Heart Chakra is the spiritual center of love, compassion,
            forgiveness, and harmony. It is located in our body near the heart,
            in the middle of the chest.
          </p>
          <h2>Benefits of the Heart Chakra</h2>
          <p>The benefits of balancing the Heart Chakra are:</p>
          <ol>
            <li>
              <b>Unconditional Love:</b> The ability to love oneself and others
              unconditionally develops.
            </li>
            <li>
              <b>Deep Compassion:</b> The ability to recognize the suffering of
              others and show compassion.
            </li>
            <li>
              <b>Forgiveness:</b> The ability to forgive oneself and others for
              the hurts one has caused.
            </li>
            <li>
              <b>Harmony in Relationships:</b> One can develop loving and
              harmonious relationships.
            </li>
            <li>
              <b>Physical Well-being:</b> The functioning of organs such as the
              heart, lungs, and chest cavity improves.
            </li>
            <h2>Yoga Poses for Balancing the Anagatha Chakra </h2>
            <p>
              These poses expand the chest, open the heart, and allow the energy
              of love to flow.
            </p>
          </ol>
          <h2>Bhujangasana - Cobra Pose</h2>
          <p>
            <b>How to do it:</b> Lie on your stomach, place your hands under
            your shoulders, and slowly lift your upper body up. Push your chest
            forward.
          </p>
          <img
            src={h1}
            alt="Bhujangasana (Cobra Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Stretches the chest and encourages energy flow to
            the heart area.
          </p>

          <h2>Ustrasana - Camel Pose</h2>
          <p>
            <b>How to do it:</b> Stand on your knees, place your hands on your
            heels, and lift your chest up and arch your back.
          </p>
          <img
            src={h2}
            alt="Ustrasana (Camel Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> A powerful pose that fully opens the chest and
            heart area.
          </p>

          <h2>Anahatasana - Melting Heart Pose</h2>
          <p>
            <b>How to do it:</b> Stand with your legs spread wide apart, lean
            forward, chest as close to the ground as possible, and arms straight
            ahead.
          </p>
          <img
            src={h3}
            alt="Anahatasana (Melting Heart Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Provides a gentle stretch to the shoulders and
            chest, releasing tension from the heart area.
          </p>

          <h2>Matsyasana - Fish Pose</h2>
          <p>
            <b>How to do it:</b> Lie on your back, support yourself with your
            elbows, lift your chest up, and bend your head so that the hair
            touches the floor.
          </p>
          <img
            src={h4}
            alt="Matsyasana (Fish Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Opens the chest, neck, and shoulders, and deepens
            breathing.
          </p>

          <p>
            <b>Green:</b> Seeing, wearing, or imagining the color green around
            you can increase chakra energy.
          </p>
          <p>
            <b>Mantra:</b> Chanting the mantra "Yam" during meditation can
            increase the vibration of this chakra.
          </p>
          <p>
            By practicing these yoga asanas and practices daily, you can balance
            your Anakat Chakra and bring love, compassion, and inner peace into
            your life.
          </p>
        </>
      ),
    },
    {
      name: "Vishuddha Chakra or Throat Chakra",
      img: pose5,
      alt: "Vishuddha Chakra",
      sanskrit: "Vishuddha Chakra",
      english: "Throat Chakra",
      location: "Throat",
      color: "Blue",
      mantra: "Ham",
      petals: 16,
      element: "Space",
      focus: "Self-expression and communication",
      content: (
        <>
          <h2>Throat Chakra</h2>
          <p>
            The Vishuddha Chakra is located in the throat. It is called the
            "Throat Chakra". It is associated with the color light blue or
            bright blue. This chakra is considered the center of communication,
            self-expression, truth, unity, and acceptance. It is the control
            center for expressing our ideas and feelings.
          </p>
          <h2>Benefits of Balancing Vishuddha Chakra</h2>
          <p>
            When the Vishuddha Chakra is balanced, the following benefits are
            available:
          </p>
          <ol>
            <li>
              <b>Improved communication skills:</b> You gain the ability to
              express your thoughts clearly, boldly, and effectively.
            </li>
            <li>
              <b>Expression of Truth:</b> It helps you express your authentic
              self and speak the truth.
            </li>
            <li>
              <b>Creative expression:</b> You will excel in creative activities
              such as singing, writing, and poetry.
            </li>
            <li>
              <b>Active listening:</b> The ability to fully listen to what
              others are saying (Active Listening) develops.
            </li>
            <li>
              <b>Self-expression:</b> You can express your feelings and needs
              more easily.
            </li>
            <li>
              <b>Following your inner guidance:</b> Your ability to listen to
              your inner voice will increase.
            </li>
          </ol>
          <h2>Yoga Poses for Balancing the Vishuddha Chakra</h2>
          <p>
            The following yoga poses will help you stretch the throat and neck
            area and focus on the Vishuddha Chakra.{" "}
          </p>
          <h2>Matsyasana - Fish Pose</h2>
          <p>
            <b>How to do it:</b> Lie back on the bed, lift your chest up, and
            rest the crown of your head on the floor. Imagine that your entire
            throat is lengthening and expanding.
          </p>
          <img
            src={t1}
            alt="Matsyasana (Fish Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Fully expands the throat and neck area, directly
            opening the Vishuddha Chakra.
          </p>

          <h2>Halasana - Plough Pose</h2>
          <p>
            <b>How to do it:</b> Lie on the bed, lift your legs behind your
            head, and try to touch your toes to the floor.
          </p>
          <img
            src={t2}
            alt="Halasana (Plough Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood flow to the neck and throat area
            and relieves tension in this area.
          </p>

          <h2>Adho Mukha Svanasana - Downward-Facing Dog</h2>
          <p>
            <b>How to do it:</b> Place your hands and feet on the floor and lift
            your back up to form a 'V' shape.
          </p>
          <img
            src={t3}
            alt="Adho Mukha Svanasana (Downward-Facing Dog) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood flow to the head and helps activate
            the throat area.
          </p>

          <h2>Balasana - Child's Pose</h2>
          <p>
            <b>How to do it:</b> Sit on your knees, bend forward, and let your
            forehead touch the floor.
          </p>
          <img
            src={t4}
            alt="Balasana (Child's Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Calms the mind and helps relieve tension in the
            throat.
          </p>

          <h2>Sarvangasana - Shoulderstand</h2>
          <p>
            <b>Caution:</b> People with neck or back injuries should not do
            this.
          </p>
          <img
            src={t5}
            alt="Sarvangasana (Shoulderstand) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> This is known as the "pose of all the organs". It
            increases blood flow to the neck and throat area and stimulates the
            Vishuddhi Chakra in a powerful way.
          </p>

          <h2>Ustrasana - Camel Pose</h2>
          <p>
            <b>How to do it:</b> Stand on your knees, bend your back, and hold
            your heels with your hands. Let your throat expand.
          </p>
          <img
            src={t6}
            alt="Ustrasana (Camel Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> The entire front body, especially the throat and
            neck, is well stretched, which helps activate this chakra.
          </p>

          <p>
            <b>Other exercises for the Vishuddhi Chakra</b>
          </p>
          <ul>
            <li>
              <b>Meditation:</b> Visualize a light blue light in your throat and
              chant the mantra "Ham".
            </li>
            <li>
              <b>Ujjayi Breath:</b> Ujjayi Breath is very effective. This "ocean
              sound" breath activates the throat and cleanses the chakra.
            </li>
            <li>
              <b>Hum Kriya:</b> Saying the sound 'Hum' out loud or mentally.
            </li>
            <li>
              <b>Singing:</b> Any type of singing is a great way to activate the
              throat chakra.
            </li>
          </ul>
          <p>
            <b>Important Note:</b> Balancing the Vishuddhi Chakra comes as much
            from listening to what we say as from what we say. This chakra is
            also balanced by listening to the opinions of others with respect.
          </p>
        </>
      ),
    },
    {
      name: "Ajna Chakra or Third Eye Chakra",
      img: pose6,
      alt: "Ajna Chakra",
      sanskrit: "Ajna Chakra",
      english: "Third Eye Chakra",
      location: "Between the eyebrows",
      color: "Indigo",
      mantra: "Om",
      petals: 12,
      element: "The universal mind",
      focus:
        "Intuition, decision-making and the egocentric intellect in favor of attaining nondualistic wisdom.",
      content: (
        <>
          <h2>Third Eye Chakra - Introduction</h2>
          <p>
            The Ajna Chakra is located in the middle of the forehead, between
            the eyebrows. It is also known as the "third eye" chakra. It is
            associated with the color blue or indigo. This chakra is considered
            the center of intuition, cognition, imagination, and spiritual
            clarity.
          </p>
          <h2>Benefits of Balancing Ajna Chakra</h2>
          <p>
            When the Ajna Chakra is balanced, the following benefits are
            available:
          </p>
          <ol>
            <li>
              Intuition development: Your intuition becomes sharper. This
              greatly helps in making important decisions.
            </li>
            <li>
              Mental clarity: Confused thoughts decrease and the ability to
              understand any matter clearly increases.
            </li>
            <li>Imagination: Creativity and imagination increase.</li>
            <li>
              Spiritual clarity: There is a sense of self and connection with
              the universe.
            </li>
            <li>
              Freedom from anxiety and fear: Due to deep understanding,
              non-violence (fear) and anxiety will decrease.
            </li>
            <li>
              Siddhi: The ability to focus on one thing (concentration) will
              improve.
            </li>
            <li>
              Increased memory: Due to the concentration of the mind, the power
              of memory will be strengthened.
            </li>
            <h2>Yoga Poses to Balance the Ajna Chakra:</h2>
            <p>
              The following yoga poses help to focus on the Ajna Chakra and
              balance it.
            </p>
          </ol>
          <h2>Balasana - Child's Pose</h2>
          <p>
            <b>How to do it:</b> Sit on your knees, bend forward, and let your
            forehead touch the floor.
          </p>
          <img
            src={e1}
            alt="Balasana (Child's Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Calms the mind and increases blood flow to the
            forehead (Ajna Chakra).
          </p>

          <h2>Adho Mukha Svanasana - Downward-Facing Dog</h2>
          <p>
            <b>How to do it:</b> Place your hands and feet on the floor, lift
            your back up, and form a 'V' shape. The head should be drooping.
          </p>
          <img
            src={e2}
            alt="Adho Mukha Svanasana (Downward-Facing Dog) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood flow to the head and clears the
            mind.
          </p>

          <h2>Matsyasana - Fish Pose</h2>
          <p>
            <b>How to do it:</b> Lie back on the bed, lift your chest up, and
            place the crown of your head on the floor.
          </p>
          <img
            src={e3}
            alt="Matsyasana (Fish Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Stretches the neck and head, stimulating the Anjali
            Chakra.
          </p>

          <h2>Sirsasana - Headstand</h2>

          <img
            src={e4}
            alt="Sirsasana (Headstand) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Note:</b> This is an advanced asana; should only be done under
            the supervision of an experienced teacher.
          </p>
          <p>
            <b>Benefits:</b> Increases blood flow to the head, improving the
            functioning of the Anjali Chakra. Increases intuition and focus.
          </p>

          <h2>Padmasana - Lotus Pose</h2>
          <p>
            <b>How to do it:</b> Sit in Dandasana with your legs crossed. Back
            straight, hands in Jnana Mudra (thumb and index finger joined).
          </p>
          <img
            src={e5}
            alt="Padmasana (Lotus Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> A pose that stabilizes the mind and is suitable for
            meditation. It directly stimulates the function of the Anja Chakra.
          </p>

          <h2>Other exercises for the Anja Chakra</h2>
          <ul>
            <li>
              <b>Meditation:</b> Focusing on the center of the forehead and
              chanting the mantra "Om".
            </li>
            <li>
              <b>Pranayama:</b> Breathing exercises such as Nadi Shodhana, which
              involves alternating left-right nostril breathing, can calm the
              mind.
            </li>
            <li>
              <b>Abhishekam:</b> Applying sandalwood or saffron on the forehead
              can create a sensation in the area.
            </li>
          </ul>
        </>
      ),
    },
    {
      name: "Sahasrara Chakra or Crown Chakra",
      img: pose7,
      alt: "Sahasrara Chakra",
      sanskrit: "Sahasrara Chakra",
      english: "Crown Chakra",
      location: "Just above the crown of the head",
      color: "Encompasses all colors",
      mantra: "Encompasses all sound",
      petals: 1000,
      element: "The ultimate reality of all truth",
      focus:
        "Detachment from ego and illusory nature of the material world, attaining the goal of yoga(Self-realization).",
      content: (
        <>
          <h2>Crown Chakra:</h2>
          <p>
            The Sahasrara Chakra is located at the top of the head. It means a
            thousand-petalled lotus. It is associated with the color purple or
            white. This chakra is considered the center of higher knowledge,
            union with God, spiritual wisdom, and connection with the Supreme
            Being. It is the point of termination and complete union of all
            other chakras.
          </p>
          <h2>Benefits of Balancing Sahasrara Chakra</h2>
          <p>
            When the Sahasrara Chakra is balanced, the following benefits are
            achieved:
          </p>
          <ol>
            <li>
              <b>Higher consciousness:</b> You experience a higher level of
              spirituality, peace, and perfection.
            </li>
            <li>
              <b>Connection with the Supreme Being:</b> You experience the union
              of the individual soul (Atman) with the Supreme Being
              (Paramatman/Brahman).
            </li>
            <li>
              <b>Deep peace and happiness:</b> There is a deep inner peace and
              abiding happiness that transcends worldly concerns.
            </li>
            <li>
              <b>Unlimited Love:</b> There will be unlimited, unconditional love
              for all beings except oneself.
            </li>
            <li>
              <b>True Knowledge:</b> True Enlightenment and knowledge of the
              nature of the universe will be gained.
            </li>
            <li>
              <b>Freedom from ego:</b> The egoistic thoughts of "I", "mine" will
              decrease, and a vast sense of completeness will arise.
            </li>
            <li>
              <b>Feeling beyond the body and mind:</b> A sense of pure spiritual
              essence will arise.
            </li>
          </ol>
          <h2>Yoga Poses to Balance the Sahasrara Chakra</h2>
          <p>
            Since the Sahasrara Chakra is towards the top of the head, asanas
            that increase blood flow to the head and calm the mind are useful.
          </p>
          <h2>Sirsasana - Headstand(Also known as Raja Asana.)</h2>

          <img
            src={c1}
            alt="Sirsasana (Headstand) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood flow to the head and directly
            stimulates the Sahasrara Chakra. Increases mental clarity.
          </p>
          <p>
            <b>Warning:</b> Should only be done under the supervision of an
            experienced teacher.
          </p>

          <h2>Adho Mukha Svanasana - Downward-Facing Dog</h2>
          <p>
            <b>How to do it:</b> Place your hands and feet on the floor, and
            lift your back up to form a 'V' shape.
          </p>
          <img
            src={c2}
            alt="Adho Mukha Svanasana (Downward-Facing Dog) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Increases blood flow to the head, clears the mind,
            and helps balance the Sahasrara chakra.
          </p>

          <h2>Matsyasana - Fish Pose</h2>
          <p>
            <b>How to do it:</b> Lie back on the bed, lift your chest up, and
            place the crown of your head on the floor.
          </p>
          <img
            src={c3}
            alt="Matsyasana (Fish Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Stretches the neck and head, opening the Sahasrara
            chakra.
          </p>

          <h2>Padmasana - Lotus Pose</h2>
          <p>
            <b>How to do it:</b> Sit in Dandasana with your legs crossed. Keep
            your back straight and your hands in Jnana Mudra.
          </p>
          <img
            src={c4}
            alt="Padmasana (Lotus Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> This is an important meditation pose. It helps
            stabilize the mind and reach higher spiritual states.
          </p>

          <h2>Balasana - Child's Pose</h2>
          <p>
            <b>How to do it:</b> Sit on your knees, bend forward, and touch your
            forehead to the floor.
          </p>
          <img
            src={c5}
            alt="Balasana (Child's Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Calms the mind and stimulates inner awareness,
            which helps to establish a connection with the Sahasrara Chakra.
          </p>

          <h2>Savasana - Corpse Pose</h2>
          <p>
            <b>How to do it:</b> Lie down on the bed first, spread your arms and
            legs, and close your eyes for complete relaxation.
          </p>
          <img
            src={c6}
            alt="Savasana (Corpse Pose) yoga pose"
            style={{
              width: "100%",
              maxWidth:
                window.innerWidth <= 375 && window.innerHeight <= 667
                  ? "260px"
                  : "350px",
              height: "auto",
              display: "block",
              margin: "20px auto",
              borderRadius: 8,
            }}
          />
          <p>
            <b>Benefits:</b> Deeply relaxing the mind and body, leading to
            higher levels of awareness and spiritual connection.
          </p>

          <h2>Other exercises for the Sahasrara Chakra</h2>
          <ul>
            <li>
              <b>Meditation:</b> Focus your attention on the crown of your head.
              The chanting of the mantra "Om" is considered very powerful for
              activating this chakra.
            </li>
            <li>
              <b>Silence:</b> Practicing silence for a long time can clear the
              mind and promote connection with the Sahasrara Chakra.
            </li>
            <li>
              <b>Realization:</b> The practice of feeling that the Supreme Being
              is showering mercy on all beings and on oneself.
            </li>
          </ul>
          <p>
            <b>Important Note:</b> The Sahasrara Chakra is a very subtle and
            spiritual chakra. Rather than trying to "activate" it, it will
            naturally open through balancing the other chakras, meditation, and
            a pure lifestyle. As always, practice these exercises with patience
            and optimism.
          </p>
        </>
      ),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: ismobile ? "10px" : "30px 10px",
        marginTop: 40,
      }}
    >
      <Layout style={{ flex: 1, minWidth: 0, background: "transparent" }}>
        <Content style={wrapperStyle}>
          {/* Dropdown */}
          <motion.div
            style={{ textAlign: "center", marginBottom: 20 }}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <select
              style={selectStyle}
              className="manrope_font"
              onChange={(e) => {
                const selected = details.find((c) => c.name === e.target.value);
                setSelectedChakra(selected);
              }}
            >
              <option value="">-- Select a Chakra --</option>
              {details.map((c, index) => (
                <option key={index} value={c.name}>
                  {c.name}
                </option>
              ))}
            </select>
          </motion.div>

          {/* Conditional rendering */}
          <AnimatePresence mode="wait">
            {selectedChakra ? (
              // SHOW ONLY SELECTED CHAKRA
              <motion.div
                className="manrope_font"
                key={selectedChakra.name}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -30 }}
                transition={{ duration: 0.6 }}
                style={{ marginTop: 30 }}
              >
                <h2 style={{ textAlign: "center" }}>{selectedChakra.name}</h2>
                <motion.img
                  src={selectedChakra.img}
                  alt={selectedChakra.name}
                  style={imageStyle}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                />
                <table className="manrope_font" style={tableStyle}>
                  <tbody>
                    <tr>
                      <td style={cellStyle}>
                        <b>Sanskrit</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.sanskrit}</td>
                    </tr>
                    <tr>
                      <td style={cellStyle}>
                        <b>English</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.english}</td>
                    </tr>
                    <tr>
                      <td style={cellStyle}>
                        <b>Location</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.location}</td>
                    </tr>
                    <tr>
                      <td style={cellStyle}>
                        <b>Color</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.color}</td>
                    </tr>
                    <tr>
                      <td style={cellStyle}>
                        <b>Mantra</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.mantra}</td>
                    </tr>
                    {selectedChakra.element && (
                      <tr>
                        <td style={cellStyle}>
                          <b>Element</b>
                        </td>
                        <td style={cellStyle}>{selectedChakra.element}</td>
                      </tr>
                    )}
                    <tr>
                      <td style={cellStyle}>
                        <b>Petals</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.petals}</td>
                    </tr>
                    <tr>
                      <td style={cellStyle}>
                        <b>Focus</b>
                      </td>
                      <td style={cellStyle}>{selectedChakra.focus}</td>
                    </tr>
                  </tbody>
                </table>
                {selectedChakra.content && (
                  <motion.div
                    style={{ marginTop: 20 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                  >
                    {selectedChakra.content}
                  </motion.div>
                )}
              </motion.div>
            ) : (
              <motion.div
                key="chakra-default"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -30 }}
                transition={{ duration: 0.6 }}
              >
                <h2 style={{ textAlign: "center" }}>Chakra</h2>

                <img src={chakra} alt="Chakra" style={imageStyle} />

                <div style={{ textAlign: "left" }}>
                  <h2>Chakra:</h2>
                  <p>
                    This is what is meant by the concept of "chakras" in yoga
                    and spiritual traditions.
                  </p>
                  <p>
                    In this context, chakras are energy centers within the human
                    body. They are visualized as energy wheels located along the
                    spine, from the base of the spine to the crown of the head.
                    Each chakra is associated with specific physical, emotional,
                    and spiritual aspects of our being.
                  </p>

                  <h2>There are said to be seven main chakras:</h2>
                  <ol>
                    <motion.img
                      src={pose1}
                      alt="Mooladhara Chakra (Root Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Mooladhara Chakra (Root Chakra):</b> Located at the
                      base of the spine. Associated with survival, protection,
                      and stability.
                    </li>

                    <motion.img
                      src={pose2}
                      alt="Swadhishthana Chakra (Sacral Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Swadhishthana Chakra (Sacral Chakra):</b> Located in
                      the lower abdomen. Associated with creativity, sexuality,
                      and emotion.
                    </li>

                    <motion.img
                      src={pose3}
                      alt="Manipuraka Chakra (Solar Plexus Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Manipuraka Chakra (Solar Plexus Chakra):</b> Located in
                      the upper abdomen. Associated with personal power,
                      self-esteem, and confidence.
                    </li>

                    <motion.img
                      src={pose4}
                      alt="Anahata Chakra (Heart Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Anahata Chakra (Heart Chakra):</b> Located in the
                      center of the chest. Associated with love, compassion, and
                      connection.
                    </li>

                    <motion.img
                      src={pose5}
                      alt="Vishuddhi Chakra (Throat Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Vishuddhi Chakra (Throat Chakra):</b> Located in the
                      throat. Associated with communication and self-expression.
                    </li>

                    <motion.img
                      src={pose6}
                      alt="Anjna Chakra (Third Eye Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Anjna Chakra (Third Eye Chakra):</b> Located between
                      the eyebrows. Associated with intuition, wisdom, and
                      insight.
                    </li>

                    <motion.img
                      src={pose7}
                      alt="Sahasrara Chakra (Crown Chakra)"
                      style={imageStyle}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <li>
                      <b>Sahasrara Chakra (Crown Chakra):</b> Located at the top
                      of the head. Associated with spiritual connection and
                      wisdom.
                    </li>
                  </ol>

                  <p>
                    The goal of many yogic practices is to balance these
                    chakras, allowing energy (kundalini or shakti — called
                    shakti in Tamil) to flow freely upward, leading to greater
                    health and spiritual awareness.
                  </p>

                  <div>
                    <h2>Significance in Tamil Culture:</h2>
                    <ul>
                      <li>
                        The concept of chakras is deeply intertwined in Siddha
                        medicine and Tamil spiritual traditions, which are
                        ancient systems native to Tamil Nadu.
                      </li>
                      <li>
                        In Siddha medicine, the balance of these key energy
                        points is crucial for physical and mental well-being.
                      </li>
                      <li>
                        Chakras are also central to the worship of the Divine
                        Mother or Shakti in Tamil Nadu, as the rising Kundalini
                        energy is seen as a manifestation of the Goddess.
                      </li>
                    </ul>

                    <h2>Abstract</h2>
                    <ul>
                      <li>
                        <b>Literal meaning:</b> Chakra, circle, wheel.
                      </li>
                      <li>
                        <b>Spiritual meaning:</b> The energy centers in the body
                        that govern our physical, emotional, and spiritual
                        health.
                      </li>
                      <li>
                        <b>Cultural context:</b> A fundamental concept in yoga,
                        Siddha medicine, and Tamil spiritual practices.
                      </li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </Content>
      </Layout>
      {!ismobile && <AdvertisementCard />}
    </div>
  );
};

export default Chakra;
